export enum CardStatusEnum {
  PendingActivation = 0,
  Activated = 1,
  Paid = 2,
  InProduction = 3,
  Replaced = 4,
  CardClosed = 6,
  WaitForClosure = 7,
  Shipped = 18,

  ClosedAccount = 46,
  ExpiredCard = 54,

}

export enum VulnerableTypeEnum {
  None = 0,
  Debt = 1,
  Garnishment = 2,
  Prison = 3,
  Other = 99,
}
